import { StyleProp, View, ViewStyle } from "react-native";
import { Avatar, Button, IconButton, Text, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  text: string;
  onWhatsappHelpButtonPress: () => void;
  onClose?: () => void;
  style?: StyleProp<ViewStyle>;
};

export default function ErrorView({
  text,
  onWhatsappHelpButtonPress,
  onClose,
  style,
}: Props) {
  const { colors } = useTheme();
  const tailwind = useTailwind();

  return (
    <View
      style={[
        tailwind("flex-1 flex-col items-center px-4 justify-center relative"),
        style,
      ]}
    >
      {onClose && (
        <IconButton
          icon="close"
          style={tailwind("absolute top-6 right-6")}
          iconColor={colors.onSurface}
          onPress={onClose}
        />
      )}

      <Avatar.Text
        label="🤷‍♀️"
        size={128}
        color={colors.primary}
        style={{ backgroundColor: colors.elevation.level0 }}
      />

      <Text style={tailwind("text-center mb-12")} variant="headlineSmall">
        {text}
      </Text>

      <Button
        onPress={onWhatsappHelpButtonPress}
        mode="contained"
        icon={"whatsapp"}
      >
        Chatear
      </Button>
    </View>
  );
}
